import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#F0F0F0\" d=\"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12\"></path><path fill=\"#F0F0F0\" d=\"M0 12c0 4.549 2.53 8.506 6.26 10.541V1.46A12 12 0 0 0 0 12\"></path><path fill=\"#496E2D\" d=\"M12 0C9.923 0 7.968.53 6.263 1.46v21.082C7.967 23.472 9.922 24 12 24c6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12\"></path><path fill=\"#F0F0F0\" d=\"M17.132 13.986a3.391 3.391 0 1 1-2.426-6.112A4.174 4.174 0 1 0 18.2 12.71a3.4 3.4 0 0 1-1.07 1.275M17.069 7.827l.855.922 1.14-.529-.612 1.098.856.922-1.234-.243-.612 1.098-.15-1.248-1.234-.243 1.14-.529z\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }